/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Type of user ID
 */
export const UserType = {
  Internal: "internal",
  External: "external",
} as const;
/**
 * Type of user ID
 */
export type UserType = ClosedEnum<typeof UserType>;

/**
 * Top user by activity
 */
export type TopUser = {
  /**
   * Number of messages (session mode) or tool calls (tool_call mode)
   */
  activityCount: number;
  /**
   * User ID (internal or external depending on availability)
   */
  userId: string;
  /**
   * Type of user ID
   */
  userType: UserType;
};

/** @internal */
export const UserType$inboundSchema: z.ZodMiniEnum<typeof UserType> = z.enum(
  UserType,
);

/** @internal */
export const TopUser$inboundSchema: z.ZodMiniType<TopUser, unknown> = z.pipe(
  z.object({
    activity_count: z.int(),
    user_id: z.string(),
    user_type: UserType$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "activity_count": "activityCount",
      "user_id": "userId",
      "user_type": "userType",
    });
  }),
);

export function topUserFromJSON(
  jsonString: string,
): SafeParseResult<TopUser, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TopUser$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TopUser' from JSON`,
  );
}
